import React, { createContext, useContext, useEffect, useState } from 'react'
import { Link } from 'react-router-dom';

import './Stepper.css'


export function Stepper({ 
		steps , 
		activeStep,
		onStepClick = () => {} , 
		children}){


	return (
		<div className="stepper">
			{
				steps.map( (step , index) => {
					return (
						<div key={index} className="stepper-stepContainer" onClick={() => onStepClick(index)}>
							<div className="stepper-stepNumberWrapper">
								<span className={`stepper-stepNumber ${activeStep === index ? 'isFilled' : ''}`}>{index+1}</span>
							</div>
							<span className="stepper-stepTitle">{step?.label}</span>
							{ step?.description && <span className="stepper-stepDesc">{step?.description}</span> }
						</div>
				 	)
				})
			}
			<div className="stepper-lineContainer">
				{
					steps.map( (step , index) => {
						return (
							<hr key={index} className={`stepper-line ${activeStep === index ? 'isFilled' : ''}`} />
						)
					})
				}
				 
			</div>
		</div>

	)
}

// const TabContext = createContext({
// 	activeStep: '',
// 	setActiveStep: () => {},
//   });


// export function Stepper({ initialId , children }) {

// 	const [activeStep, setActiveStep] = useState( initialId ?? '')

// 	useEffect(() => {
 
// 		//console.log('activeStep : ' , activeStep);
// 		//console.log('initialId : ' , initialId);
// 		if(initialId) setActiveStep(initialId)	
// 		//console.log('activeStep : ' , activeStep);
// 	}, [])
	
// 	const handleHeaderClick = (event) => {
// 		// do something
// 		event.stopPropagation();
// 	};
	

// 	return (
// 		<TabContext.Provider value={{ activeStep , setActiveStep }}>
// 			<div 
// 				className={`stepper`}
// 				onClick={handleHeaderClick}
// 				>{ children }</div>	
// 		</TabContext.Provider>
// 	)

// }
// /**
//  * 
//  * @param {*} param0 
//  * @returns 
//  */
// function Step({ label , description , children }) {

// 	const { activeStep, setActiveStep } = useContext(TabContext);


// 	return (
// 		<div className={`stepper-item`}>
//             <div>{label}</div>
//             <div>{description}</div>
// 			<div 
//                 // onClick={ () => setActiveStep(id)}
//                 className="tab-item-link">{ children }</div> 
// 		</div>
// 	)
// }

// Stepper.Step = Step
